// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /exchange: full-screen "processing login" state. Scoped to .exchange-page. */
.exchange-page {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 100vh;
  min-height: 100svh;
  padding: 24px 16px calc(24px + env(safe-area-inset-bottom));
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  text-align: center;
}

.exchange-page__spinner {
  width: clamp(48px, 16vw, 70px);
  aspect-ratio: 1;
  margin-bottom: 12px;
  border: 6px solid #ccc;
  border-top-color: #0062cc;
  border-radius: 50%;
  animation: exchange-page-spin 1s linear infinite;
}

@keyframes exchange-page-spin {
  to {
    transform: rotate(360deg);
  }
}

.exchange-page__title {
  margin: 0;
  max-width: 32ch;
  color: #333;
  font-size: clamp(1.125rem, 1rem + 0.8vw, 1.25rem);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.exchange-page__subtitle {
  margin: 0;
  max-width: 40ch;
  color: #555;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/ExchangePage.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2DAA2D;EAC3D,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* /exchange: full-screen \"processing login\" state. Scoped to .exchange-page. */\n.exchange-page {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 100vh;\n  min-height: 100svh;\n  padding: 24px 16px calc(24px + env(safe-area-inset-bottom));\n  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);\n  text-align: center;\n}\n\n.exchange-page__spinner {\n  width: clamp(48px, 16vw, 70px);\n  aspect-ratio: 1;\n  margin-bottom: 12px;\n  border: 6px solid #ccc;\n  border-top-color: #0062cc;\n  border-radius: 50%;\n  animation: exchange-page-spin 1s linear infinite;\n}\n\n@keyframes exchange-page-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.exchange-page__title {\n  margin: 0;\n  max-width: 32ch;\n  color: #333;\n  font-size: clamp(1.125rem, 1rem + 0.8vw, 1.25rem);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.exchange-page__subtitle {\n  margin: 0;\n  max-width: 40ch;\n  color: #555;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
